import { Checkbox, Modal } from 'antd';
import React, { useState } from 'react';
import useUtil from '../../../../hooks/useUtil';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/rootReducer';
import { COMPLETE_TYPE } from '../../../../pages/tutor/assess';
import { useTranslation } from 'react-i18next';

type AIProofreadingGuidePropTypes = {
  isOpen: boolean,
  setIsOpen: (isOpen: boolean) => void,
  onReportSaveSubmit: (completeStatus: string) => void
  submitType: string,
  displayName: string,
  activityName: string,
  isReadOnly: boolean,
  originalWordCount: number,
  errorWordCount: number,
  setOriginalWordCount: (originalWordCount: number) => void,
  setErrorWordCount: (errorWordCount: number) => void,
  rewriteOriginalWordCount: number,
  rewriteErrorWordCount: number,
  setRewriteOriginalWordCount: (originalWordCount: number) => void,
  setRewriteErrorWordCount: (errorWordCount: number) => void,
  isOkText: string
}

const OverallWordCheckModal = ({
                                 isOpen,
                                 setIsOpen,
                                 onReportSaveSubmit,
                                 submitType = COMPLETE_TYPE.COMPLETED,
                                 displayName,
                                 activityName,
                                 isReadOnly,
                                 originalWordCount,
                                 errorWordCount,
                                 setOriginalWordCount,
                                 setErrorWordCount,
                                 rewriteOriginalWordCount,
                                 rewriteErrorWordCount,
                                 setRewriteErrorWordCount,
                                 setRewriteOriginalWordCount,
                                 isOkText
                               }: AIProofreadingGuidePropTypes) => {

  const { t, i18n } = useTranslation();
  const onReportSaveSubmitMiddleware = async () => {
    onReportSaveSubmit(submitType);
    setIsOpen(false);
  }

  return (
    <Modal
      title="Report Card Metric Variation Rate Check"
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      footer={[
        <>
          <button type="button" className="ant-btn ant-btn-primary" onClick={onReportSaveSubmitMiddleware}>
            <span>{isOkText}</span>
          </button>
          <button type="button" className="ant-btn ant-btn-default" onClick={() => setIsOpen(false)}>
            <span>{t('common.button.close')}</span>
          </button>
        </>,
      ]}
    >
      <div className="ant-descriptions ant-descriptions-small ant-descriptions-bordered">
        <div className="ant-descriptions-view">
          <table>
            <tbody>
            <tr className="ant-descriptions-row">
              <th
                className="ant-descriptions-item-label text-center"
                style={{ width: '20%' }}
              >
                <span></span>
              </th>
              <th
                className="ant-descriptions-item-label text-center"
                style={{ width: '40%' }}
              >
                <span>Time to Write</span>
              </th>
              <th
                className="ant-descriptions-item-label text-center"
                style={{ width: '40%' }}
              >
                <span>{activityName}</span>
              </th>
            </tr>
            <tr className="ant-descriptions-row">
              <td className="ant-descriptions-item-content">
                <span>Total Words</span>
              </td>
              <td className="ant-descriptions-item-content">
            <span>
              <input
                type="text"
                className="form-control text-center"
                value={originalWordCount}
                onChange={(e: any) => setOriginalWordCount(e.currentTarget.value)}
                disabled={isReadOnly}
              />
            </span>
              </td>
              <td className="ant-descriptions-item-content">
            <span>
              <input
                type="text"
                className="form-control text-center"
                value={rewriteOriginalWordCount}
                onChange={(e: any) => setRewriteOriginalWordCount(e.currentTarget.value)}
                disabled={isReadOnly}
              />
            </span>
              </td>
            </tr>
            <tr className="ant-descriptions-row">
              <td className="ant-descriptions-item-content">
                <span>Grammar Errors</span>
              </td>
              <td className="ant-descriptions-item-content">
            <span>
              <input
                type="text"
                className="form-control text-center"
                value={errorWordCount}
                onChange={(e: any) => setErrorWordCount(e.currentTarget.value)}
                disabled={isReadOnly}
              />
            </span>
              </td>
              <td
                className="ant-descriptions-item-content"
                style={{ width: '35%' }}
              >
            <span>
              <input
                type="text"
                className="form-control text-center"
                value={rewriteErrorWordCount}
                onChange={(e: any) => setRewriteErrorWordCount(e.currentTarget.value)}
                disabled={isReadOnly}
              />
            </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-3">
        <p className="rc-info">
          {t('class.tutor.message6')}
        </p>
      </div>
    </Modal>
  )
}

export default OverallWordCheckModal;